import {  FormGroup, NonIdealState } from "@blueprintjs/core";
import React from "react";
import { connect } from "react-redux";

import { DictionaryEntryFormPanel } from "./DictionaryEntryForm";
import LabelProvider from "./LabelProvider";

/**
 * @description
 * get's a panel's registered label provider and renders a list of available labels for editing.
 *
 * @author chris
 */

interface IPanelLabelListProps {
	instance: string;
}

interface IStateProps {
	id?: string;
}

function mapStateToProps(state: any, ownProps: IPanelLabelListProps): IStateProps {
	return {
		id: state.config.panels[ownProps.instance] && state.config.panels[ownProps.instance].id
	};
}

type ResultProps = IStateProps & IPanelLabelListProps;

const PanelLabelList = (props: ResultProps) => {

	if (!props.id) {
		return null;
	}

	const labelProvider = LabelProvider.getProvider(props.id);

	if (!labelProvider) {
		return (
			<NonIdealState title="No Labels" description="No Label Provider is registered for this panel type." />
		);
	}

	return labelProvider.renderEditPanel([props.instance, props.id]);
};

export default connect(mapStateToProps)(PanelLabelList);



// WEBPACK FOOTER //
// ./src/core/components/label/PanelLabelList.tsx